import { Icon } from "semantic-ui-react";

import "components/StatusIcon/StatusIcon.scss";
import { COMMUNICATION_STATUSES, STATUS_IDENTIFIERS } from "models";

type AppointmentStatusValue = {
  id: STATUS_IDENTIFIERS;
  car_in_shop?: string | null;
  car_check_paused_at?: string | null;
  car_out_of_shop?: string | null;
  customcom_status?: COMMUNICATION_STATUSES | null;
};

export type StatusIconProps = {
  status: STATUS_IDENTIFIERS;
  color?: string;
  className?: string;
  showSubIcon?: boolean;
  appointment?: AppointmentStatusValue;
};

export const carInShopStatus = (appointment?: AppointmentStatusValue) => appointment?.car_in_shop && !appointment.car_out_of_shop;

export const StatusIcon = ({ status, appointment, color, className = "", showSubIcon = true }: StatusIconProps) => {
  const iconProps = { style: color ? { color } : undefined };

  switch (status) {
    case STATUS_IDENTIFIERS.CanceledStatus:
      return <Icon key={STATUS_IDENTIFIERS.CanceledStatus} className={`circle xmark ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CarOutOfShop:
      return <Icon key={STATUS_IDENTIFIERS.CarOutOfShop} className={`car mirrors ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.NewCarStatus:
      return (
        <Icon key={STATUS_IDENTIFIERS.NewCarStatus} className={carInShopStatus(appointment) ? `car garage ${className}` : `car mirrors ${className}`} {...iconProps} />
      );

    case STATUS_IDENTIFIERS.CarCheckStatus:
      return <Icon key={STATUS_IDENTIFIERS.CarCheckStatus} className={`wrench ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.PricingOKStatus:
      return <Icon key={STATUS_IDENTIFIERS.PricingOKStatus} className={`tag ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CustomerOKStatus:
      return <Icon key={STATUS_IDENTIFIERS.CustomerOKStatus} className={`face smile regular ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CarReadyStatus:
      return <Icon key={STATUS_IDENTIFIERS.CarReadyStatus} className={`check double ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.DiagnoseStatus:
      return <Icon key={STATUS_IDENTIFIERS.DiagnoseStatus} className={`triangle exclamation ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.AannameOKStatus:
      return <Icon key={STATUS_IDENTIFIERS.AannameOKStatus} className={`square a ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CalculatingStatus:
      return <Icon key={STATUS_IDENTIFIERS.CalculatingStatus} className={`dollar sign ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.ContactStatus:
      if (Number(appointment?.customcom_status) >= COMMUNICATION_STATUSES.DiagnoseOverviewSent) {
        return <Icon key={STATUS_IDENTIFIERS.ContactStatus} className={`mail ${className}`} {...iconProps} />;
      }
      return <Icon key={STATUS_IDENTIFIERS.ContactStatus} className={`phone volume ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CarCheckStartedStatus:
      if (appointment?.car_check_paused_at) {
        return <Icon key={STATUS_IDENTIFIERS.CarCheckStartedStatus} className={`circle pause ${className}`} {...iconProps} />;
      }

      return <Icon key={STATUS_IDENTIFIERS.CarCheckStartedStatus} className={`circle quarter stroke ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.QualityCheckStatus:
      return <Icon key={STATUS_IDENTIFIERS.QualityCheckStatus} className={`shield check ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CustomerAnsweredStatus:
      return <Icon key={STATUS_IDENTIFIERS.CustomerAnsweredStatus} className={`user check ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.BackOrder:
      return (
        <div key={STATUS_IDENTIFIERS.BackOrder} className={`bo-icon ${className}`} {...iconProps}>
          BO
        </div>
      );

    case STATUS_IDENTIFIERS.HandleCheckIn:
      return <Icon key={STATUS_IDENTIFIERS.HandleCheckIn} className={`calendar check ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CheckInDone:
      return (
        <span key={STATUS_IDENTIFIERS.CheckInDone}>
          <Icon className="car mirrors" />
          <Icon className="calendar check top-right" />
        </span>
      );

    case STATUS_IDENTIFIERS.CarInShop:
      return <Icon key={STATUS_IDENTIFIERS.CarInShop} className={`car garage ${className}`} {...iconProps} />;

    case STATUS_IDENTIFIERS.CarOkPlusRepairOverivew:
      if (!showSubIcon) return <Icon key={STATUS_IDENTIFIERS.CarOkPlusRepairOverivew} className={`check double ${className}`} {...iconProps} />;
      return (
        <span key={STATUS_IDENTIFIERS.CarOkPlusRepairOverivew}>
          <Icon className="check double" />
          <Icon className="envelope top-right" />
        </span>
      );

    case STATUS_IDENTIFIERS.QualityCheckPlusRepairOverview:
      if (!showSubIcon) return <Icon key={STATUS_IDENTIFIERS.QualityCheckPlusRepairOverview} className={`shield check ${className}`} {...iconProps} />;
      return (
        <span key={STATUS_IDENTIFIERS.QualityCheckPlusRepairOverview}>
          <Icon className="shield check" />
          <Icon className="envelope top-right" />
        </span>
      );

    default:
      return null;
  }
};
